module.exports = __webpack_public_path__ + "static/media/aa_circle_triangle.021b67fe.png";